// extracted by mini-css-extract-plugin
export var active = "_qa-1";
export var circle = "_qa-0";
export var completed = "_qa-2";
export var connector = "_qa-4";
export var connectorCompleted = "_qa-7";
export var connectorSpacer = "_qa-5";
export var iconStrokeOverride = "_qa-8";
export var labelContainer = "_qa-6";
export var pending = "_qa-3";